import React from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import ColorLensIcon from "@mui/icons-material/ColorLens";

const SettingsMenu = ({
  anchorEl,
  onClose,
  onUserProfile,
  onSystemPreferences,
  onThemeSettings,
  hasPermission,
  collapsed,
}) => {
  const menuItems = [
    {
      label: "Profile Settings",
      icon: <AccountCircleIcon fontSize="small" />,
      onClick: onUserProfile,
      permission: "manage_profile",
    },
    {
      label: "System Preferences",
      icon: <SettingsIcon fontSize="small" />,
      onClick: onSystemPreferences,
      permission: "manage_system",
    },
    {
      label: "Theme Settings",
      icon: <ColorLensIcon fontSize="small" />,
      onClick: () => {
        onThemeSettings();
        onClose();
      },
      permission: "manage_theme",
    },
  ];

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          mt: 1,
          minWidth: 230,
          borderRadius: "16px",
          backgroundColor: "rgba(255,255,255,0.96)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 18px 45px rgba(0,0,0,0.18)",
          border: "1px solid rgba(47,99,173,0.10)",
          overflow: "hidden",
          py: 1,
        },
      }}
      MenuListProps={{
        sx: {
          p: 1,
        },
      }}
    >
      {menuItems.map(({ label, icon, onClick, permission }) =>
        hasPermission(permission) ? (
          <Tooltip key={label} title={collapsed ? label : ""} placement="right">
            <MenuItem
              onClick={() => {
                onClick();
                onClose();
              }}
              sx={{
                minHeight: 46,
                borderRadius: "12px",
                mx: 0.5,
                my: 0.25,
                px: 1.25,
                transition: "all 0.2s ease",
                color: "#223142",
                "&:hover": {
                  backgroundColor: "rgba(47,99,173,0.08)",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 36,
                  color: "#2f63ad",
                }}
              >
                {icon}
              </ListItemIcon>

              {!collapsed && (
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    color: "#223142",
                  }}
                />
              )}
            </MenuItem>
          </Tooltip>
        ) : null
      )}
    </Menu>
  );
};

export default SettingsMenu;